import metaObject from "@/.sourceflow/metadata.json";
import PostFilters from "@/components/Shared/PostFilters";
import SubBanner from "@/components/SubBanner";
import sourceflowEnums from "@/sourceflow.enums";
import { SourceFlowHead } from "@sourceflow-uk/sourceflow-head";
import { Collection, Global } from "@sourceflow-uk/sourceflow-sdk";
import ReadyCTABanner from "components/ReadyCTABanner";

import { router } from "@/routes";
import { useRouter } from "next/router";

function getSlugFromPathname(pathname) {
  const segments = pathname.split("/").filter(Boolean);
  const slug = segments.pop();
  return slug.charAt(0).toUpperCase() + slug.slice(1);
}

export default function Resources({ global, meta, blogs, blog_category, blog_tags }) {
  const { pathname } = useRouter();
  const slug = getSlugFromPathname(pathname);

  return (
    <>
      <SourceFlowHead
        metaObject={metaObject}
        title={meta.title}
        description={meta.description}
        canonical={meta.canonical}
      />
      <div className="bg-light-white">
        <SubBanner
          global={global}
          pathPrefix={`${slug}.resources.page.sub_banner`}
          heading={`${slug}`}
          content={<p>Amet eget a mauris quis dignissim lacus lectus nec. Suspendisse</p>}
          breadcrumb_title={
            <>
              <span>Resources</span>
              <span className="active">{slug}</span>
            </>
          }
          // wave_color={`light-grey`}
          className={`resources-page pt-5`}
          waveIcon={false}
        />
        <PostFilters
          global={global}
          pathPrefix={`${slug}.resources.page.post_filters`}
          post={blog_category}
          post2={blog_tags}
          origin_post={blogs}
          pagePrefix={`/`}
          pagePrefixTag={`${
            slug == "Recorded-training"
              ? "/recorded-training"
              : slug == "Blog"
                ? "/blog"
                : slug == "Events"
                  ? "/events"
                  : slug == "Downloads"
                    ? "/downloads"
                    : slug == "Reviews"
                      ? "/reviews"
                      : ""
          }/tags/`}
        />
        <div className="my-5"></div>
        <ReadyCTABanner
          global={global}
          pathPrefix={`${slug}.resources.page.ready_cta_banner`}
          cta_title_1={`Send Resume`}
        />
      </div>
    </>
  );
}

export async function getStaticProps() {
  const global = (await Global()).toJson();

  const blogs = (await Collection(`recorded-training`))
    .filter((post) => {
      // Blog value id
      return post?.blog_category.en.includes("59167e78-6611-4a4f-98fc-c1d2413c2eaf");
    })
    .orderBy(["published_date.en"], ["desc"])
    .getItems();
  const blog_tags = (await Collection(`blog_tags`)).getItems();
  const blog_category = (await Collection(`blog_category`)).getItems();

  const routerKey = "recorded-training";

  return {
    props: {
      global,
      blogs,
      blog_category,
      blog_tags,
      meta: {
        title: "Recorded-Training | Tradewind Subs",
        description: `${sourceflowEnums.seo.genericDescription}`,
        canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]}`,
      },
    },
  };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search
